import deleteMailListRows from './deleteMailListRows';
import { TableView } from 'owa-mail-list-store';

export default function emptySearchTableView(tableView: TableView) {
    return deleteMailListRows(tableView.rowKeys, tableView.id, false /* isExplicitSoftDelete */);
}
